
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

const FasClubeCadastro = () => {
  const [nome, setNome] = useState('');
  const [cidade, setCidade] = useState('');
  const [descricao, setDescricao] = useState('');
  const [logoUrl, setLogoUrl] = useState('/placeholder.svg');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setIsLoggedIn(true);
    } else {
      toast.error("Você precisa estar logado para criar um fã clube");
      navigate('/login');
    }
  }, [navigate]);

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // Simulate image upload - in a real app, this would upload to a server
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          setLogoUrl(reader.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!nome || !cidade) {
      toast.error("Por favor, preencha todos os campos obrigatórios.");
      return;
    }
    
    // Get existing fan clubs or initialize empty array
    const existingFasClubes = JSON.parse(localStorage.getItem('fasClubes') || '[]');
    
    // Create new fan club
    const newFasClube = {
      id: Date.now().toString(),
      nome,
      cidade,
      descricao,
      logo: logoUrl,
      membros: [],
      createdAt: new Date().toISOString(),
      owner: JSON.parse(localStorage.getItem('user') || '{}').fullName,
    };
    
    // Add to local storage
    localStorage.setItem('fasClubes', JSON.stringify([...existingFasClubes, newFasClube]));
    
    toast.success('Fã Clube cadastrado com sucesso!');
    navigate('/fas-clubes');
  };

  if (!isLoggedIn) return null;

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 container mx-auto px-4 pt-24 pb-10">
        <div className="bg-black/60 p-8 rounded-lg">
          <h1 className="text-3xl font-bold mb-6 text-center">Cadastrar Novo Fã Clube</h1>
          
          <div className="max-w-2xl mx-auto">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="flex flex-col md:flex-row gap-4 items-center justify-center mb-6">
                <div className="relative">
                  <Avatar className="h-32 w-32">
                    <AvatarImage src={logoUrl} alt="Logo Preview" />
                    <AvatarFallback>FC</AvatarFallback>
                  </Avatar>
                  <label 
                    htmlFor="logo-upload"
                    className="absolute bottom-0 right-0 bg-rustico-brown text-white p-2 rounded-full cursor-pointer"
                  >
                    Alterar
                  </label>
                  <input 
                    id="logo-upload"
                    type="file" 
                    accept="image/*"
                    className="hidden"
                    onChange={handleImageUpload}
                  />
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-white mb-1">Nome do Fã Clube*</label>
                  <Input 
                    id="nome"
                    type="text" 
                    placeholder="Ex: Fãs de The Walking Dead" 
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    required
                    className="bg-[#333] text-white border-none"
                  />
                </div>

                <div>
                  <label htmlFor="cidade" className="block text-sm font-medium text-white mb-1">Cidade*</label>
                  <Input 
                    id="cidade"
                    type="text" 
                    placeholder="Ex: São Paulo" 
                    value={cidade}
                    onChange={(e) => setCidade(e.target.value)}
                    required
                    className="bg-[#333] text-white border-none"
                  />
                </div>

                <div>
                  <label htmlFor="descricao" className="block text-sm font-medium text-white mb-1">Descrição</label>
                  <Textarea 
                    id="descricao"
                    placeholder="Descreva seu fã clube..." 
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    rows={4}
                    className="bg-[#333] text-white border-none"
                  />
                </div>
              </div>

              <div className="pt-4">
                <button 
                  type="submit"
                  className="w-full bg-rustico-brown hover:bg-[#6f5f3f] text-white font-bold py-3 px-4 rounded transition-colors"
                >
                  Cadastrar Fã Clube
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FasClubeCadastro;
